export default "__VITE_ASSET__xCgcekWL__"